/**
 * @public
 */
export var DeviceType;
(function (DeviceType) {
    DeviceType["Android"] = "Android";
    DeviceType["Browser"] = "Browser";
    DeviceType["Chromecast"] = "Chromecast";
    DeviceType["Generic"] = "Generic";
    DeviceType["Ion"] = "Ion";
    DeviceType["Kepler"] = "Kepler";
    DeviceType["Kpn"] = "Kpn";
    DeviceType["Llama"] = "Llama";
    DeviceType["MultiChoiceRdk"] = "MultiChoiceRdk";
    DeviceType["Netgem"] = "Netgem";
    DeviceType["OneSdk"] = "OneSdk";
    DeviceType["Prospero"] = "Prospero";
    DeviceType["Quest"] = "Quest";
    DeviceType["RDK"] = "RDK";
    DeviceType["Tizen"] = "Tizen";
    DeviceType["Vidaa"] = "Vidaa";
    DeviceType["Vizio"] = "Vizio";
    DeviceType["WebMaf"] = "WebMaf";
    DeviceType["WebOS"] = "WebOS";
    DeviceType["WinUI2"] = "WinUI2";
    DeviceType["XboxOne"] = "XboxOne";
    DeviceType["XboxSeries"] = "XboxSeries";
    DeviceType["Xfinity"] = "Xfinity";
    DeviceType["YouView"] = "YouView";
    DeviceType["Zenterio"] = "Zenterio";
})(DeviceType || (DeviceType = {}));
//# sourceMappingURL=device-type.js.map